import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { AppConfigService } from 'src/app/app-config.service';

@Injectable({ providedIn: 'root' })
export class ApiService {
    constructor(private httpClient: HttpClient, private config: AppConfigService) {

    }

    private getFullUrl(resourceUri: string) {
        return `${this.config.settings.apiURL}/${resourceUri}`;
    }

    async post<T>(resourceUri: string, body?: any | null, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType: 'json';
        withCredentials?: boolean;
    }) {
        return await this.httpClient.post<T>(this.getFullUrl(resourceUri), body, options).toPromise();
    }

    async get<T>(resourceUri: string, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }) {
        return await this.httpClient.get<T>(this.getFullUrl(resourceUri), options).toPromise();
    }

    async put<T>(resourceUri: string, body: any | null, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType: 'arraybuffer';
        withCredentials?: boolean;
    }) {
        return await this.httpClient.put(this.getFullUrl(resourceUri), body, options).toPromise();
    }

    async delete(resourceUri: string, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType: 'arraybuffer';
        withCredentials?: boolean;
    }) {
        await this.httpClient.delete(this.getFullUrl(resourceUri), options).toPromise();
    }

}